/*
  Вход в кабинет.

  Одно поле почты, одно поле пароля и одна кнопка. Ответ на неверный пароль
  сервер даёт тот же, что на неизвестную почту, — и экран не пытается угадать,
  что именно не так: подсказка «такой почты нет» превратила бы форму входа в
  способ перечислить сотрудников организации.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { Notice } from '../components/Common.jsx'
import { BrandMark } from '../components/Icons.jsx'

export default function LoginPage({ onEntered }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      const issued = await api.login(email.trim(), password)
      onEntered(issued.user)
    } catch (failure) {
      setError(failure)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit}>
        {/* Знак продукта: вход - единственный экран без боковой колонки, и
            узнать по нему, куда пришёл, больше не по чему. */}
        <div className="login__mark">
          <BrandMark />
        </div>
        <div className="login__brand">Арбитр ЖКХ</div>
        <div className="login__note">Конвейер взыскания задолженности за жилищно-коммунальные услуги</div>

        <label className="field">
          <span className="field__label">Рабочая почта</span>
          <input
            className="field__input"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label className="field">
          <span className="field__label">Пароль</span>
          <input
            className="field__input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        {/*
          🔴 Ошибка стоит НАД кнопкой, а не над формой (09.09.2026, правило 3
          скилла `frontend`: ошибка живёт рядом с действием, которое её
          вызвала). Наверху карточки, под названием продукта, она читалась как
          сообщение обо всём кабинете, а глаз человека в этот момент внизу - на
          кнопке, которую он только что нажал.
        */}
        <Notice error={error} wide />

        <button className="button login__submit" type="submit" disabled={busy}>
          {busy ? 'Проверяем…' : 'Войти'}
        </button>

        <p className="login__help muted">
          Учётную запись заводит руководитель организации. Он же назначает новый пароль, если
          прежний забыт.
        </p>
      </form>
    </div>
  )
}
